export type Env = "local" | "dev" | "qa" | "uat" | "prod";

const isEnv: Record<Env, (hostname: string) => boolean> = {
  local: () => false, // (hostname) => hostname === 'localhost',
  dev: (hostname) => hostname === "login.dev.carrier.io",
  qa: (hostname) => hostname === "login.qa.carrier.io",
  uat: (hostname) => hostname === "login.preprod.carrier.io",
  prod: (hostname) => hostname === "login.preprod.carrier.io",
};

export const getEnv = (hostname: string) => {
  return (
    (Object.keys(isEnv).find((env) => isEnv[env as Env](hostname)) as Env) ||
    "dev"
  );
};
